import React, { Component } from 'react';
import { Form, Input, Button, message, Select, Icon, Modal } from 'antd';
import { minimalTimezoneSet } from 'compact-timezone-list';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _isEqual from 'lodash/isEqual';
// import moment from 'moment';

import { putExchange, getExchange, requestApplyOnKit } from '../../common/fetch';
import { SetupAction, ExchangeAction } from '../../actions';
import { checkURL } from '../../common/utils';
import { FormWrapper } from './style';
import { renderCountries } from '../VerifyAgree/Utils';

// NOTE Insert the Tehran data
minimalTimezoneSet.splice(15, 0, {
	label: '(GMT+03:30) Tehran',
	offset: '+03:30',
	tzCode: 'Asia/Iran',
});

const { Item } = Form;

class Step1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isVisible: false,
			isApplyConfirm: false,
			isLoading: false
		}
	}

	componentDidMount() {
		const { exchange, history, initialValues } = this.props;
		const { setFieldsValue } = this.props.form;
		if (Object.keys(exchange).length === 0) {
			history.push('/');
		}
		setFieldsValue(initialValues);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!_isEqual(prevProps.initialValues, this.props.initialValues)) {
			const { setFieldsValue } = this.props.form;
			setFieldsValue(this.props.initialValues);
		}
	}

	handleSubmit = async (e) => {
		e.preventDefault();
		const { biz, form } = this.props;
		form.validateFieldsAndScroll((err) => {
			if (!err) {
				if (biz.hasOwnProperty('id')) {
					this.updateExchange();
				}
			}
		});
	};

	updateExchange = async () => {
		const { biz, setupActions, exchange = {} } = this.props;
		const { getFieldsValue, getFieldValue } = this.props.form;
		this.setState({ isLoading: true });

		const body = getFieldsValue();
		try {
			const exchangeBody = {
				display_name: getFieldValue('EXCHANGE_NAME'),
				id: biz.id,
				// url: getFieldValue('URL'),
				// domain: getFieldValue('DOMAIN'),
				info: {
					// biz: body,
					public: {
						title: getFieldValue('EXCHANGE_NAME'),
						country: getFieldValue('DEFAULT_COUNTRY'),
					},
					is_temp: biz.is_temp,
				},
			};
			// delete exchangeBody.info.biz.id;
			if (exchange.type !== 'Cloud') {
				exchangeBody.domain = getFieldValue('DOMAIN');
				exchangeBody.url = getFieldValue('URL');
			}
			await putExchange(exchangeBody);
			await this.getExchange();
			this.setState({ isLoading: false });
			const data = { ...biz, ...body };
			message.success('Updated successfully');
			setupActions.updateBiz({
				...data,
			});
		} catch (error) {
			this.setState({ isLoading: false });
			if (error.data
				&& error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	getExchange = async () => {
		try {
			const res = await getExchange();
			const exchange = res.data.data.sort((a, b) => {
				const ad = new Date(a.updated_at);
				const bd = new Date(a.updated_at);
				if (Math.floor(ad - bd) >= 0) {
					return a - b;
				} else {
					return b - a;
				}
			});

			this.props.storeExchange(exchange);
		} catch (error) {
			if (error && error.data) {
				message.error(error.data.message)
			}
		}
	};

	renderTimezone = () => {
		return minimalTimezoneSet.map((item) => {
			if (item.label.toLowerCase().indexOf('tokyo') >= 0) {
				return (
					<Select.Option key="Asia/Seoul" value={item.tzCode}>
						(GMT+09:00) Seoul
					</Select.Option>
				);
			}
			return (
				<Select.Option key={item.tzCode} value={item.tzCode}>
					{item.label}
				</Select.Option>
			);
		});
	};

	handleShow = () => {
		this.setState({ isVisible: !this.state.isVisible });
	};

	handleApply = () => {
		this.setState({ isApplyConfirm: true });
	};

	handleClose = () => {
		this.setState({ isApplyConfirm: false });
	};

	handleConfirm = async () => {
		try {
			await requestApplyOnKit(this.props.exchange.id);
			this.handleClose();
			message.success('Applied updates successfully');
		} catch (error) {
			this.handleClose();
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	getDisabledState = () => {
		const { form = {}, initialValues } = this.props;
		const { getFieldsValue } = form;
		const currentValues = getFieldsValue();
		if (!_isEqual(initialValues, currentValues)) {
			return false;
		} else {
			return true;
		}
	};

	render() {
		const { getFieldDecorator } = this.props.form;
		const { exchange = {} } = this.props;
		const { isVisible, isApplyConfirm, isLoading } = this.state;
		const submitDisabled = this.getDisabledState();
		return (
			<FormWrapper width='100%'>
				<div className="section-wrapper">
					<Form onSubmit={this.handleSubmit}>
						<Item>
							<h3>Exchange ID name</h3>
							{getFieldDecorator('NAME', {
								initialValue: `${exchange.name} - ${exchange.id}`
							})(<Input className="medium-width" disabled placeholder="Exchange ID Name" />)}
						</Item>
						<Item>
							<h3>Display Name</h3>
							{getFieldDecorator('EXCHANGE_NAME')(
								<Input className="medium-width" placeholder="Exchange Name" />
							)}
						</Item>
						<Item>
							<h3>Exchange API URL</h3>
							{getFieldDecorator('URL', {
								rules: [
									{
										validator: checkURL
									}
								]
							})(
								<Input
									className="medium-width"
									placeholder="your exchange api url"
									disabled={exchange.type === 'Cloud'}
								/>
							)}
						</Item>
						<Item>
							<h3>Exchange Domain</h3>
							{getFieldDecorator('DOMAIN', {
								rules: [
									{
										validator: checkURL
									}
								]
							})(
								<Input
									className="medium-width"
									placeholder="Your exchange domain"
									disabled={exchange.type === 'Cloud'}
								/>
							)}
						</Item>
						<Item>
							<h3>Country</h3>
							{getFieldDecorator('DEFAULT_COUNTRY')(
								<Select className="medium-width">
									<Select.Option value="">Select country</Select.Option>
									{renderCountries()}
								</Select>
							)}
						</Item>
						{/*<Item>
							<h3>Time Zone</h3>
							{getFieldDecorator('TIME_ZONE')(
								<Select>
									<Select.Option value="UTC">UTC</Select.Option>
									{this.renderTimezone()}
								</Select>
							)}
						</Item>
						<Item className="last">
							<h3>Language</h3>
							{getFieldDecorator('LANGUAGE')(
								<Select className="medium-width">
									<Select.Option value="en">English</Select.Option>
									<Select.Option value="ko">Korean</Select.Option>
								</Select>
							)}
						</Item>
						{/* <Item>
							<h3>Exchange Description</h3>
							<p>
								In a couple of sentences, share why your exchange is
								unique. This description can be used to market your
								exchange and help towards crowd-sourcing liquidity
							</p>
							{getFieldDecorator('EXCHANGE_DESC')(
								<TextArea placeholder="Exchange Description" />
							)}
						</Item> */}
						<Button block type="primary" htmlType="submit" disabled={isLoading || submitDisabled}>
							Save
						</Button>
					</Form>
				</div>
				{/* <div className="section-wrapper">
					<div className='quick-restart-card'>
						<div className="sub-heading-label">Quick Restart</div>
						<div>
							Quick restart applies any changes made from the dashboard to your live exchange. It uses the API URL to communicate with your exchange.
						</div>
						<Button block type="primary" onClick={this.handleApply}>
							Quick Restart
						</Button>
					</div>
				</div> */}
				<div className="section-wrapper activation-code">
					<div className="sub-heading-label">Activation code</div>
					<div className='d-flex flex-container'>
						<span>Activation code:</span>{' '}
						<div>
							<span
								className={
									isVisible
										? "code-visible"
										: "code-hidden"
								}
							>
								{exchange.activation_code}
							</span>{' '}
							<Icon
								type={
									isVisible
										? "eye-invisible"
										: "eye"
								}
								style={{ color: '#fff' }}
								onClick={this.handleShow}
							/>
						</div>
					</div>
				</div>
				{/*<div>
					<div className="sub-heading-label">Other</div>
					<div>
						<div>
							<span>Created:</span>{' '}
							<span>{moment(exchange.created_at).format('MMM DD, YYYY')}</span>
						</div>
						<div>
							<span>Expiry:</span>{' '}
							<span>{moment(exchange.expiry).format('MMM DD, YYYY')}</span>
						</div>
					</div>
				</div>*/}
				<Modal
					visible={isApplyConfirm}
					footer={null}
					onCancel={this.handleClose}
				>
					<FormWrapper>
						<div className="sub-heading-label">
							Apply changes to live exchange
						</div>
						<div className="sub-txt">
							This may affects important areas within your exchange such as assets and pairs. Do you want to apply changes to the live website now?
						</div>
						<Button
							block
							type="primary"
							className="w-100"
							onClick={this.handleConfirm}
						>
							Apply latest changes
						</Button>
					</FormWrapper>
				</Modal>
			</FormWrapper>
		);
	}
}

const General = Form.create()(Step1);

const mapStateToProps = (state) => {
	return {
		biz: state.setup.biz,
		tech: state.setup.tech,
		exchange: state.exchange[0] || {},
		constant: state.constant
	};
};

const mapDispatchToProps = (dispatch) => ({
	setupActions: bindActionCreators(SetupAction, dispatch),
	storeExchange: bindActionCreators(ExchangeAction.readData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(General);
